import { useProduct } from "src/context/ProductProvider";
import MhlImage from "./components/MhlImage";
import EDImage from "./components/EDImage";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useQuestions } from "src/context/QuestionsProvider";
import AmhReview from "./components/AmhReview";
import AmhPlan from "./components/AmhPlan";
import AmhImage from "./components/AmhImage";

const MessageImage = () => {
  const slug = useProduct((p) => p.slug);
  const tag = useQuestions((q) => q.tag);
  const { nextQuestion } = useSubmitAnswers();

  if (slug === "mhl-ot") {
    return <MhlImage />;
  }

  if (slug === "ed-ot") {
    return <EDImage onNext={nextQuestion} />;
  }

  if (slug === "amh-ot") {
    switch (tag) {
      case "AMH_REVIEW":
        return <AmhReview onNext={nextQuestion} />;
      case "AMH_PLAN":
        return <AmhPlan onNext={nextQuestion} />;
      default:
        return <AmhImage onNext={nextQuestion} />;
    }
  }
};

export default MessageImage;
